import { useState } from "react";
import { api, extractErrorMessage } from "../../../../util/api";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { Form } from "react-final-form";
import { camelizeKeys, snakifyKeys } from "../../../../util/helpers";
import { PhoneResponseForm } from "./PhoneResponseForm";

export const EditPhoneResponseModal = ({ phoneResponse, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleUpdate = async (params) => {
    setError(null);

    try {
      const res = await api.patch(`/admin/phone_responses/${params.id}`, snakifyKeys({ phone_response: params }));

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Phone Response</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={camelizeKeys({ ...phoneResponse })}>
            {(props) => <PhoneResponseForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
